<!-- 查看订单出入仓关联的标签 -->
<template>
    <div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                max-height="470px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column fixed show-overflow-tooltip width="180" prop="LabelCode" label="标签编码"></el-table-column>
                <el-table-column show-overflow-tooltip width="150" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="160" prop="GoodName" label="配件名称"></el-table-column>
                <el-table-column show-overflow-tooltip width="70" prop="PackingSpec" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="CostPrice" label="标签成本"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" label="标签总成本">
                    <template slot-scope="scope">
                        {{ (scope.row.PackingSpec * scope.row.CostPrice).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" :label="recData.Type==0?'出仓时间':'入仓时间'"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="Remark" label="备注"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: { recData: Object },
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                OrderId: this.recData.OrderId,
                GoodsId: this.recData.GoodsId,
                OrderType: this.recData.Type.toString()
            },
            tableData: []
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData.LabelCode = '';
            this.searchData.APCode = '';
            this.searchData.GoodName = '';
            this.searchData.Page = 1;
            this.searchData.Limit = 10;
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoodsLabels/GetOrderGoodsLabels',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                });
        },
        updateTableData(data) {
            this.searchData = {
                OrderId: data.OrderId,
                GoodsId: data.GoodsId,
                OrderType: data.Type.toString() 
            };
            this.getTableData();
        },
    }
};
</script>
<style lang="less" scoped>
.search-ctn-left {
    margin-bottom: 10px;

    .search-name {
        margin-bottom: 0;
    }
}
</style>
